var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"user-list__item",on:{"click":_vm.handleClick}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"user-list-item__name"},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),_c('div',{staticClass:"user-list-item__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }